function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30,28v2.133C30,34.471,26.187,38,21.5,38S13,34.471,13,30.133V19.867C13,15.529,16.813,12,21.5,12 c2.118,0,4.089,0.757,5.609,2h11.83C36.377,6.963,29.44,2,21.5,2C11.299,2,3,10.056,3,19.958v10.083C3,39.944,11.299,48,21.5,48 S40,39.944,40,30.041V28H30z M27.81,7.333c1.591,0.745,3.017,1.768,4.236,3.039l-1.443,1.385c-1.049-1.094-2.273-1.973-3.641-2.611 L27.81,7.333z M21.208,6h0.584c0.326,0,0.648,0.011,0.969,0.032l-0.137,1.996C22.349,8.009,22.071,8,21.792,8h-0.584 c-1.051,0-2.093,0.134-3.1,0.397l-0.506-1.936C18.773,6.156,19.986,6,21.208,6z M12.889,8.69l1.172,1.621 c-1.226,0.887-2.266,1.979-3.091,3.245l-1.676-1.092C10.254,10.992,11.463,9.722,12.889,8.69z M7,20.208 c0-0.984,0.102-1.968,0.302-2.925l1.957,0.41C9.087,18.515,9,19.362,9,20.208v2.136H7V20.208z M7.213,32.253 C7.072,31.449,7.001,30.621,7,29.792v-2.573h2v2.572c0.001,0.713,0.063,1.426,0.184,2.118L7.213,32.253z M12.511,41.028 c-1.392-1.078-2.559-2.387-3.468-3.891l1.711-1.035c0.782,1.293,1.785,2.418,2.981,3.346L12.511,41.028z M21.792,44h-0.584 c-1.38,0-2.745-0.198-4.06-0.588l0.57-1.918C18.847,41.83,20.021,42,21.208,42h0.584c0.145,0,0.288-0.003,0.431-0.007l0.064,1.998 C22.123,43.997,21.958,44,21.792,44z M27.379,42.86l-0.787-1.838c1.387-0.595,2.64-1.432,3.724-2.489l1.396,1.432 C30.451,41.195,28.993,42.168,27.379,42.86z M34.716,35.703l-1.818-0.832c0.628-1.372,0.991-2.834,1.081-4.346l1.996,0.117 C35.871,32.403,35.447,34.105,34.716,35.703z"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 23,
  x2: 23,
  y1: 32,
  y2: 17,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 46,
  x2: 46,
  y1: 32.111,
  y2: 17,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 8,
  x: 23,
  y: 17,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 23,
  y: 17
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 4,
  x: 27,
  y: 21
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 4,
  x: 30,
  y: 17
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 4,
  x: 33,
  y: 21
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 4,
  x: 36,
  y: 17
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 4,
  x: 39,
  y: 21
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 42,
  y: 17
});

function SvgTrackLap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackLap);
export default __webpack_public_path__ + "static/media/track-lap.94c3e5ac.svg";
export { ForwardRef as ReactComponent };